module.exports = __webpack_public_path__ + "static/media/todo_project.d13d7bac.jpg";